<template>
  <WdsText
    :secondary="!responsibility"
    :text="responsibility ? responsibilityLabel(responsibility) : '—'"
    :data-test="`owner-responsibility-${rowIndex}`"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { responsibilityLabel } from '@/components/Owners/responsibilities'

const OwnerResponsibilityColumn = graphql(`
  fragment OwnerResponsibilityColumn on Owner {
    id
    responsibility
  }
`)

const props = defineProps<{
  row: FragmentType<typeof OwnerResponsibilityColumn>
  rowIndex?: number
}>()

const responsibility = computed(
  () => useFragment(OwnerResponsibilityColumn, props.row).responsibility,
)
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
